// pages/Resources/ResourcesIndex.js
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { resourcesData } from '../../data/resourcesData';
import './ResourcesIndex.css';

const ResourcesIndex = () => {
  const { t, i18n } = useTranslation();
  const [activeCategory, setActiveCategory] = useState('all');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const categories = [
    { id: 'all', labelKey: 'resourcesPage.categories.all' },
    { id: 'route-optimization', labelKey: 'resourcesPage.categories.route-optimization' },
    { id: 'workforce-management', labelKey: 'resourcesPage.categories.workforce-management' },
    { id: 'scheduling', labelKey: 'resourcesPage.categories.scheduling' },
    { id: 'utilities', labelKey: 'resourcesPage.categories.utilities' },
    { id: 'logistics', labelKey: 'resourcesPage.categories.logistics' },
    { id: 'technical-documentation', labelKey: 'resourcesPage.categories.technical-documentation' }
  ];

  // Filter resources based on selection
  const filteredResources = activeCategory === 'all'
    ? resourcesData
    : resourcesData.filter(res => res.categories.includes(activeCategory));

  return (
    <div className="resources-page-wrap">
      <div className="resources-hero">
        <h1>{t('resourcesPage.title')}</h1>
        <p>{t('resourcesPage.subtitle')}</p>
      </div>

      {/* Category Filter Tabs */}
      <div className="resources-filter-container">
        {categories.map(cat => (
          <button
            key={cat.id}
            className={`filter-tab-btn ${activeCategory === cat.id ? 'active' : ''}`}
            onClick={() => setActiveCategory(cat.id)}
          >
            {t(cat.labelKey)}
          </button>
        ))}
      </div>

      {/* List Grid */}
      <div className="resources-list-grid">
        {filteredResources.map(res => {
          // Localize details
          const content = i18n.language.startsWith('tr') ? res.tr : res.en;

          return (
            <div className="resource-card" key={res.id}>
              <div className="resource-meta">
                <span className="resource-date">{res.date}</span>
                <span className="resource-author">{content.author}</span>
              </div>

              <h3>{content.title}</h3>
              <p>{content.excerpt}</p>

              <div className="resource-tags">
                {res.categories.map(cat => (
                  <span className="tag-pill" key={cat}>
                    {cat.replace('-', ' ')}
                  </span>
                ))}
              </div>

              <button 
                className="resource-card-link"
                onClick={() => alert("Detailed view is in development. Check back soon!")}
                style={{ marginTop: '1.5rem' }}
              >
                {t('resourcesPage.readMore')} →
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ResourcesIndex;
